// extracted by mini-css-extract-plugin
export default {"productCarousal":"Slider_productCarousal__Q8n+M","preBtn":"Slider_preBtn__yFrOa","nextBtn":"Slider_nextBtn__K7YRV","myCardCaption":"Slider_myCardCaption__f5vVB"};